
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCatalogProductView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"masterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogMasterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDetailByCatalogMasterId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogMasterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogMasterId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"catalogProductDetailViewFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviewOverview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"textReviewsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"translatedReviewsCount"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Settings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageDomainPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveriesDisplayMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showUnitPrices"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isWishlistAllowed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isNewShoppingCartEndpointEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureSwitches"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppFeatureSwitches"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shopSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"userProductsInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"masterId"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isComparison"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currentLocale"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceDecimalPlaces"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceFormat"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCurrency"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cartId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comparisonIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sid"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":959}};
    doc.loc.source = {"body":"#import \"./fragCatalogProductDetailView.graphql\"\n#import \"@hooks/useFeatureSwitches/featureSwitchesFragment.graphql\"\nquery getCatalogProductView($masterId: String!, $catalogMasterId: String!) {\n  productDetailByCatalogMasterId(catalogMasterId: $catalogMasterId) {\n    ...catalogProductDetailViewFragment\n    reviewOverview {\n      count\n      rating\n      textReviewsCount\n      translatedReviewsCount\n    }\n  }\n  Settings {\n    imageDomainPath\n    deliveriesDisplayMode\n    showUnitPrices\n    isWishlistAllowed\n    isNewShoppingCartEndpointEnabled\n    featureSwitches {\n      ...AppFeatureSwitches\n    }\n  }\n  shopSettings {\n    countryCode\n  }\n  userProductsInfo(productIds: [$masterId]) {\n    productId\n    isComparison\n  }\n  currentLocale {\n    id\n    tag\n    currency\n    priceDecimalPlaces\n    priceFormat\n  }\n  currentCurrency {\n    id\n    code\n    symbol\n  }\n  user {\n    id\n    role\n    cartId\n    consent\n    comparisonIds\n    consent\n    sid\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./fragCatalogProductDetailView.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@hooks/useFeatureSwitches/featureSwitchesFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getCatalogProductView"] = oneQuery(doc, "getCatalogProductView");
        

doc.documentId = "80309c2c3b57afac3a8168ef67051ac6cd4f4e8c8b05dc981d36a067333dbfd0"